import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const LesMarques = () => {
  return (
    <div className="content flex flex-col 900:gap-[70px] xl:gap-[100px] py-[30px] sm:py-[50px] 1400:px-0 px-[16px]">
      <h1 className="font-clash text-[40px] sm:text-[50px] hidden 900:flex leading-[1] 900:text-[80px] 900:leading-[64px] font-[600] text-dark">
        Nos pièces par marque de voiture
      </h1>

      <div className="flex flex-wrap justify-center items-center gap-[12px] sm:gap-[20px] 900:gap-[55px]">
        <Company brand="renault" />
        <Company brand="peugeot" />
        <Company brand="citroen" />
        <Company brand="volkswagen" />
        <Company brand="ford" />
        <Company brand="fiat" />
        <Company brand="bmw" />
        <Company brand="kia" />
        <Company brand="mazda" />
        <Company brand="mercedes" />
        <Company brand="chevrolet" />
        <Company brand="subaru" />
        <Company brand="nissan" />
        <Company brand="mitsubishi" />
        <Company brand="suzuki" />
        <Company brand="toyota" />
        <Company brand="hyundai" />
        <Company brand="audi" />
      </div>
    </div>
  );
};

export default LesMarques;

export const Company = ({ brand }) => {
  const BRANDS_MAP = {
    renault: {
      filterName: 'RENAULT',
      src: '/companies/p1.png',
    },
    peugeot: {
      filterName: 'PEUGEOT',
      src: '/companies/p2.png',
    },
    citroen: {
      filterName: 'CITROEN',
      src: '/companies/p3-1.png',
    },
    kia: {
      filterName: 'KIA',
      src: '/companies/p4.png',
    },
    mazda: {
      filterName: 'MAZDA',
      src: '/companies/p5.png',
    },
    mercedes: {
      filterName: 'MERCEDES',
      src: '/companies/p6.png',
    },
    chevrolet: {
      filterName: 'CHEVROLET',
      src: '/companies/p7.png',
    },
    subaru: {
      filterName: 'SUBARU',
      src: '/companies/p8.png',
    },
    bmw: {
      filterName: 'BMW',
      src: '/companies/p10.png',
    },
    ford: {
      filterName: 'FORD',
      src: '/companies/p11.png',
    },
    nissan: {
      filterName: 'NISSAN',
      src: '/companies/p12.png',
    },
    volkswagen: {
      filterName: 'VOLKSWAGEN',
      src: '/companies/p13.png',
    },
    mitsubishi: {
      filterName: 'MITSUBISHI',
      src: '/companies/p14.png',
    },
    suzuki: {
      filterName: 'SUZUKI',
      src: '/companies/p15.png',
    },
    toyota: {
      filterName: 'TOYOTA',
      src: '/companies/p16.png',
    },
    hyundai: {
      filterName: 'HYUNDAI',
      src: '/companies/p18.png',
    },
    fiat: {
      filterName: 'FIAT',
      src: '/companies/p19.png',
    },
    audi: {
      filterName: 'AUDI',
      src: '/companies/p21.png',
    },
  };

  const brandData = BRANDS_MAP[brand];

  return (
    <Link
      to={`/catalogue/marque-${brandData.filterName}`}
      className="center"
    >
      <img
        src={brandData.src}
        className="max-w-[52px] sm:max-w-[70px] lg:max-w-[80px] xl:max-w-[90px] h-auto"
        alt={brandData.filterName}
      />
    </Link>
  );
};

Company.propTypes = {
  src: PropTypes.string,
};
